import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router';

import App from './App.vue'

import 'mdb-vue-ui-kit/css/mdb.min.css';
import './assets/styles/style.css';
import HomeIndex from './components/Home/HomeIndex.vue';
import DiagnosisIndex from './components/Como_Funciona/DiagnosisIndex.vue';
import ContactIndex from './components/Resultados/ContactIndex.vue';
import AboutIndex from './components/Por_que/AboutIndex.vue';
import PreciosIndex from './components/Precios/PreciosIndex.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faInstagram, faWhatsapp, faTiktok, faFontAwesome } from '@fortawesome/free-brands-svg-icons'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

library.add(fas, faFontAwesome, faFacebookF, faInstagram, faTiktok, faWhatsapp, faUserSecret)
const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', redirect: '/Home' },
        { path: '/Home', component: HomeIndex },
        { path: '/como_funciona', component: DiagnosisIndex },
        { path: '/resultados', component: ContactIndex },
        { path: '/por_que', component: AboutIndex },
        { path: '/precios', component: PreciosIndex },
    ]
});

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router);
app.mount('#app')
